import type { LoadableType } from '@confluence/loadable';
import { LoadablePaint } from '@confluence/loadable';
import type { RecommendedPageBannerProps } from './RecommendedPageBanner.ts';

export const RecommendedPageBanner: LoadableType<RecommendedPageBannerProps> = LoadablePaint({
	loader: () =>
		import(
			/* webpackChunkName: "loadable-RecommendedPageBanner" */ '../src/RecommendedPageBanner.tsx'
		).then((module) => module.RecommendedPageBanner),
});

export type { RecommendedPageBannerProps } from '../src/RecommendedPageBanner.tsx';
